<template>
    <div @click="login" :class="{ small: smallLogo, 'vipps-button': true, disabled }">
        <div :class="{ small: smallLogo, icon: true }">
            <img v-if="!smallLogo" src="../assets/vipps-logo-2.png" alt="" />
            <img v-if="smallLogo" src="../assets/vipps-small-logo.png" alt="" />
        </div>
        <span v-if="!smallLogo" class="text">{{ translate('auth_login_button_vipps') }}</span>
    </div>
</template>

<script>
import { isLoggedIn } from '@/lib/user.js'
import thirdPartyLoginMixin from '@/mixins/3rd-party-login'
import helper from '@/lib/helper.js'
import helperMixins from '@/mixins/helper.js'
import popup from '@/lib/popup.js'

export default {
    name: 'VippsLoginButton',

    mixins: [thirdPartyLoginMixin, helperMixins],

    props: {
        webviewRedirectTo: {
            type: String,
            default: '#'
        },

        smallLogo: {
            type: Boolean,
            default: true
        },

        disabled: {
            type: Boolean,
            default: false
        },

        disabledMessage: {
            type: String,
            default: 'This feature is not available on this platform'
        }
    },

    methods: {
        isLoggedIn() {
            return isLoggedIn()
        },

        login() {
            if (this.disabled) {
                return popup.alert(this.disabledMessage)
            }

            if (this.isWebView()) {
                return this.tryRedirectLogin('vipps', this.webviewRedirectTo)
            }

            this.$emit('try-login')

            this.tryLogin('vipps')
                .then(payload => {
                    this.$emit('verified', payload.token)
                })
                .catch(() => {
                    this.$emit('fail')
                })
        },

        get3rdPartyUrl(name) {
            var params = ''

            if (!helper.desktop()) {
                params = `?is_mobile=1&redirect=${this.webviewRedirectTo}`
            }

            return `${this.loginUrl}${name}${params}`
        },

        isValidEmail(email) {
            return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(email)
        },

        isWebView() {
            return helper.webView()
        }
    }
}
</script>

<style lang="scss">
.vipps-button {
    background-color: #ff5b24;
    padding: 0.6rem;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:hover {
        background-color: rgba($color: #ff5b24, $alpha: 0.9);
    }

    .icon {
        background: #fff;
        width: 28px;
        height: 28px;
        margin-right: 1rem;
        border-radius: 3px;

        img {
            width: 100%;
        }

        &.small {
            width: 56px;
            height: 56px;
            margin: 0;
            border-radius: 8px;

            img {
                border-radius: 8px;
            }
        }
    }

    .text {
        color: #fff;
        font-size: 18px;
    }

    &.small {
        background-color: #fff;
        box-shadow: 0 0 14px rgba(0, 0, 0, 0.25);
        padding: 0;
        width: fit-content;
        height: fit-content;
        border-radius: 8px;
    }
}
</style>
